import React, { useState, useContext, useEffect } from 'react';
import logoiProv from '../../../images/i_iproveedor_blanco.png';
import { VerticalMenuItem } from './VerticalMenuItem';
import { useMenu, useMenuPerfil } from '../../../hooks/useMenu';
import './sass/verticalMenu.css';
import { ShowMessage } from '../../UI/showMessage/ShowMessage';
import { useIntl } from "react-intl";
import { TexTranslate, TexTranslateDefault } from "../../../translations/FlattenMessages";
import { ChangeCompany, RedirectInvalidUser } from "../../../service/authServices";
import { Context } from '../context/Context';
import { useCloseSessionCore, useLoginCore } from '../../../hooks/useLoginCore';
import { useEmpresas } from '../../../hooks/useEmpresas';
import { useLoader } from '../../../hooks/useLoader';

export const VerticalMenu = ({ onClickVert, typeMenu }) => {

    const [idMenu, setIdMenu] = useState(typeMenu);

    const [idSubMenu, setIdSubMenu] = useState(null);

    const intl = useIntl();

    const [principalMenu, setPrincipalMenu] = useState(true);

    const [ loginResponse, setLoginResponse] = useState(null);

    const [dataObject, setDataObject] = useState(null);

    const [dataEmpresas, setDataEmpresas] = useState(null);

    const [companyChange , setCompanyChange ] = useState(null);

    const { app, user, setUser, dataServicios, setDataServicios } = useContext(Context);

    const [ showMinSideMenu, setShowMinSideMenu ] = useState(false);

    const { closeSessionCore } = useCloseSessionCore();

    const { loginCore } = useLoginCore();

    const { selectMenu, createMenuModules, processLoginCoreMenu } = useMenu({
        setIdMenu, setIdSubMenu, setPrincipalMenu, intl, 
        app, user, setLoginResponse, setDataObject, loginCore
    });

    const { createListMenuPerfil }  = useMenuPerfil({intl, user, setCompanyChange});

    const { consultarEmpresasAdministrador } = useEmpresas({app});

    const txtLoad = TexTranslateDefault(intl, "general.Loading...");
    const {hideLoader} = useLoader({"textLoader" : txtLoad});
    
    const loadCloseSession = async () => {
        const resp = await closeSessionCore({});
        if (resp) {
            console.log("close");
        }
        RedirectInvalidUser(app);
    };

    const onEnventClickVert = (menu) => {
        onClickVert?.(menu);
    };

    const handlerClickMenu = (e, idMenuSelect, idSubMenuSelect, idMenuShow) => {
        
        const minSideBar = document.getElementById(`${idMenuSelect}Menu`);
        if( (e?.target?.id === `${idMenuSelect}Menu`) 
            || (e?.target && minSideBar?.contains(e.target))){
            return;
        } else
        if(idMenuSelect === "OUTER" && idSubMenuSelect === "OUTER"){
            if(idSubMenu !== null){
                setIdSubMenu(null);
            } else if(idMenu !== null){
                setIdMenu(null);
            }
        } else {
            selectMenu(idMenuSelect, idSubMenuSelect);
        }
        setShowMinSideMenu( (idMenuShow === idMenuSelect 
            && (idMenuSelect !== idMenu || !showMinSideMenu) )
            || (idMenuSelect === "OUTER" && idMenuShow === idMenu && false ));
    };

    const processLogOutMsg = () => {
        ShowMessage(
            {
                title: TexTranslate(intl, "alert.Confirm"),
                message: TexTranslate(intl, "general.you have requested to exit the application. do you wish to continue?"),
                typeMessage: "question",
                confirmButtonText: TexTranslate(intl, "general.accept"),
                cancelButtonText: TexTranslate(intl, "general.cancel"),
                showCancelButton: true,
                callbackConfirm: (() => {
                    loadCloseSession();

                })
            }
        );
    };

    useEffect(()=>{
        if(dataEmpresas === null){
            consultarEmpresasAdministrador({"setData" : setDataEmpresas});
        }
    },[consultarEmpresasAdministrador, dataEmpresas, setDataEmpresas]);

    useEffect(() => {
        if(idMenu === null && typeMenu !== null) {
            setIdMenu(typeMenu);
        }
    }, [idMenu, principalMenu, idSubMenu, dataServicios, showMinSideMenu, typeMenu]);

    useEffect(() => {
        if(loginResponse !== null && dataObject != null){
            processLoginCoreMenu({loginResponse, dataObject});
        }
    }, [loginResponse, dataObject, processLoginCoreMenu]);

    useEffect(() => {
        if(companyChange !== null && companyChange !== "finish"){
            ChangeCompany(companyChange, user, setUser);
            setDataServicios(null);
            setCompanyChange("finish");
        } else if(companyChange === "finish"){
            hideLoader();
            setCompanyChange(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyChange]);

    return (

        <div id="divVerticalMenu" className="sidebar">

            <VerticalMenuItem key="imgIpro" id="imgIpro" className="div-icon-menu" image={true}
                url={logoiProv} link={'/dashboardAdmin'} handlerClick={(e) => {
                    handlerClickMenu(e,"menuDashboard"); onEnventClickVert("menuDashboard");
                }}
                tooltip="iProveedor" />

            <ul className="nav_list" >
                {createMenuModules({
                    idMenu, idSubMenu, principalMenu, dataServicios, handlerClickMenu,
                    onEnventClickVert
                })}
            </ul>

            <ul className="nav_list_end">

                <VerticalMenuItem key="menuPerfil" id="menuPerfil" typeIcon={"person-circle"}
                    handlerClick={(e) => {handlerClickMenu(e,"menuPerfil", undefined, "menuPerfil"); onEnventClickVert("menuPerfil");}}
                    active={idMenu === "menuPerfil"} link={null} 
                    tooltip={TexTranslate(intl, "general.Profile")}
                    menu={createListMenuPerfil(dataEmpresas, TexTranslate(intl, "general.Profile"),handlerClickMenu,showMinSideMenu )} />

                <VerticalMenuItem key="menuOut" id="menuOut" typeIcon={"logOut"}
                    active={idMenu === "menuOut"}
                    handlerClick={(e) => {
                        handlerClickMenu(e,"menuOut"); 
                        onEnventClickVert("menuOut");
                        processLogOutMsg();
                    }}
                    link={null} tooltip={TexTranslate(intl, "general.Sign Out")} />

            </ul>

        </div>

    );

};

